import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Row, Col, Image } from 'antd'
import Link from 'next/link'

const StyledNewsBoxWrapper = styled.div`
  box-shadow: 0 8px 20px 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px !important;
  max-height: 189px;
  cursor: pointer;
  .ant-row {
    .ant-col {
      .title {
        color: var(--cognac);
      }
      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .thumbnail {
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .thumbnail, .ant-image {
      width: 107px;
      height: 107px !important;
    }
  }
`

export default function Index ({ id = '', title = '', image = '', description = '' }) {
  return (
    <Link href={`/news/${id}`}>
      <StyledNewsBoxWrapper>
        <Row align='middle'>
          <Col span={8}>
            <Image
            className='thumbnail'
            src={image}
            alt={title}
              width={150}
              height={150}
            preview={false}
          />
          </Col>
          <Col span={16}>
            <h3 className='title'>{title}</h3>
            <span className='description'>{description}</span>
          </Col>
        </Row>
      </StyledNewsBoxWrapper>
    </Link>
  )
}

Index.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string
}
